import { TInboundPlacementService } from "../features/feeSettings/feeSettingsSlice";

export const INBOUND_PLACEMENT_TYPES: TInboundPlacementService[] = [
  "Optimized",
  "Partial",
  "Minimal",
];

export const INBOUND_PLACEMENT_TOOLTIP = {
  Optimized:
    "Estimated maximum Inbound Placement Service fee for Amazon Optimized Splits.<br><br>Click to cycle through the different Inbound Placement services.",
  Partial:
    "Estimated maximum Inbound Placement Service fee for Partial Shipment Splits.<br><br>Click to cycle through the different Inbound Placement services.",
  Minimal:
    "Estimated maximum Inbound Placement Service fee for Minimal Shipment Splits.<br><br>Click to cycle through the different Inbound Placement services.",
};

export const UPDATE_DEBOUNCE_DELAY = 500;

export const DISCOUNTS = [
  "5%",
  "10%",
  "15%",
  "20%",
  "25%",
  "30%",
  "50%",
  "3 for 2",
];

export const PRODUCT_ANALYZER_COLUMNS = {
  xs: 1,
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4,
};

export const KEEPA_DURATIONS = [7, 30, 90, 180, 365, 730];

export enum Panel {
  SEARCH_AGAIN,
  PRODUCT,
  QUICK_INFO,
  RANKS_AND_PRICES,
  ALERTS,
  MARKETPLACES,
  CHARTS,
  BUY_BOX_ANALYSIS,
  ADDITIONAL_EXPENSES,
  SELLER_CENTRAL,
  PROFIT_CALCULATOR,
  VARIATIONS,
  HISTORY,
  ROI,
  KEEPA,
  NOTES_AND_TAGS,
  DISCOUNTS,
  OFFERS,
  ASIN_STATISTIC,
}

export const INIT_PANELS = {
  [Panel.PRODUCT]: { title: "Product Details", enabled: true },
  [Panel.QUICK_INFO]: { title: "Quick Overview", enabled: true },
  [Panel.RANKS_AND_PRICES]: { title: "Ranks & Pricing", enabled: true },
  [Panel.ALERTS]: { title: "Alerts", enabled: true },
  [Panel.BUY_BOX_ANALYSIS]: { title: "Buy Box Intelligence", enabled: true },
  [Panel.ADDITIONAL_EXPENSES]: { title: "Additional Expenses", enabled: true },
  [Panel.CHARTS]: { title: "Historical Charts", enabled: true },
  [Panel.PROFIT_CALCULATOR]: { title: "Profit Calculator", enabled: true },
  [Panel.VARIATIONS]: { title: "Listing Variations", enabled: true },
  [Panel.HISTORY]: { title: "History", enabled: true },
  [Panel.MARKETPLACES]: { title: "Market Scope", enabled: true },
  [Panel.SELLER_CENTRAL]: { title: "Seller Central", enabled: true },
  [Panel.SEARCH_AGAIN]: { title: "Search Again", enabled: false },
  [Panel.ROI]: { title: "R.O.I", enabled: true },
  [Panel.KEEPA]: { title: "Keepa", enabled: true },
  [Panel.NOTES_AND_TAGS]: { title: "Notes & Tags", enabled: true },
  [Panel.DISCOUNTS]: { title: "Discounts", enabled: true },
  [Panel.OFFERS]: { title: "Seller Offers", enabled: true },
  [Panel.ASIN_STATISTIC]: { title: "ASIN Statistic", enabled: true },
};

export const ROI_PERCENTS = [0, 0.1, 0.2, 0.25, 0.3, 0.4, 0.5, 0.75, 1.0, 2.0];

export const AMZ_RESPONSES = {
  NO_EXTENSION: -7,
  MISCONFIG: -6,
  UNKNOWN: -5,
  SELECT_MARKETPLACE: -4,
  WRONG_FUNCTION_PARAMS: -3,
  NOT_AUTHORISED: -2,
  NOT_LOGGED_IN: -1,
  RESPONSE_NOT_CHECKED: 0,
  RESPONSE_NOT_RESTRICTED: 1,
  RESPONSE_HAZMAT: 2,
  RESPONSE_NOT_HAZMAT: 3,
  RESPONSE_UNGATE_SUCCEED: 4,
  RESPONSE_UNGATE_FAILED: 5,
  RESPONSE_RESTRICTED: 6,
  RESPONSE_ENABLE_SINGLE_SIGN_IN: 8,
  RESPONSE_DANGEROUS: 9,
  RESPONSE_NOT_DANGEROUS: 10,
  RC_SC_LOGGED_IN: 11,
};
